import { createAnimation, isPlatform } from '@ionic/react';

export const ANIMATION_DURATION = 400;
export const pageAnimation = (baseEl: HTMLElement, opts: any, isBackAnimation = false) => {
  const enteringEl = opts.enteringEl;
  const leavingEl = opts.leavingEl;

  const rootAnimation = createAnimation();
  const enterAnimation = createAnimation();
  const leaveAnimation = createAnimation();
  const footerAnimation = createAnimation();
  const appointmentFooterEl = Array.from(document.getElementsByClassName('tabs-bar-feature'));

  if (opts.direction === 'back' && isPlatform('ios') && !isPlatform('hybrid') && !isBackAnimation) {
    enterAnimation.addElement(enteringEl).beforeStyles({ display: 'flex', opacity: 1 });

    leaveAnimation.addElement(leavingEl).beforeStyles({ display: 'flex', opacity: 1 });

    return rootAnimation.addAnimation([enterAnimation, leaveAnimation]);
  }

  enterAnimation
    .addElement(enteringEl)
    .duration(ANIMATION_DURATION)
    .easing('ease-in-out')
    .beforeStyles({ display: 'flex', opacity: 1 })
    .fromTo('transform', opts.direction === 'back' ? 'translateX(-100%)' : 'translateX(100%)', 'translateX(0)');

  leaveAnimation
    .addElement(leavingEl)
    .duration(ANIMATION_DURATION)
    .easing('ease-in-out')
    .beforeStyles({ display: 'flex', opacity: 1 })
    .fromTo('transform', 'translateX(0)', opts.direction === 'back' ? 'translateX(100%)' : 'translateX(-100%)');

  if (opts.direction === 'back') {
    footerAnimation
      .addElement(appointmentFooterEl)
      .duration(ANIMATION_DURATION)
      .easing('ease-in-out')
      .beforeStyles({ display: 'flex', opacity: 1 })
      .beforeRemoveClass('hidden')
      .afterRemoveClass(['absolute', 'bottom-0', 'left-0', 'w-full'])
      .fromTo('transform', 'translateX(-100%)', 'translateX(0)');
  } else {
    footerAnimation
      .addElement(appointmentFooterEl)
      .duration(ANIMATION_DURATION)
      .easing('ease-in-out')
      .beforeStyles({ display: 'flex', opacity: 1 })
      .afterAddClass('hidden')
      .beforeAddClass(['absolute', 'bottom-0', 'left-0', 'w-full'])
      .fromTo('transform', 'translateX(0)', 'translateX(-100%)');
  }

  rootAnimation.addAnimation([enterAnimation, leaveAnimation, footerAnimation]);
  return rootAnimation;
};
